import { type HTMLAttributes } from "react";
import { cn } from "./utils/cn";

export interface LiveStatProps extends HTMLAttributes<HTMLDivElement> {
  label: string;
  value: string;
  /** When true, renders a pulsing teal dot before the label. */
  live?: boolean;
}

export const LiveStat = ({ label, value, live = false, className, ...rest }: LiveStatProps) => (
  <div className={cn("hui-live-stat", className)} {...rest}>
    <div className="hui-live-stat__label">
      {live && <span className="hui-live-stat__pulse" aria-hidden="true" />}
      {label}
    </div>
    <div className="hui-live-stat__value">{value}</div>
  </div>
);
